export default {
  'haveRead': 'I have read, acknowledge and understand the "Details of Expenses Related to Internal Transfer".',
  'fundTransferTipsTitle': 'Details of Expenses Related to Internal Transfer',
  'fundTransferTips': {
    'exchangePriceDifferenceCompany': {
      'title': 'Exchange Difference (Charged by the Company)',
      'tips': 'If the internal transfer of the settled transactions occurs in currency that is different in various of trading accounts, the Company will make the deposit into the deposit account in the deposit currency at the bank exchange rate applicable to the Company. A currency conversion spread may occur.'
    }
  },
  'placeholderAmount': 'Please enter the amount',
  'maxText': 'Maximum Transferable Amount'
}
